export interface UiState {
  currentDropDown: string
  currentTooltip: string
}

export const initialState = {
  currentDropDown: '',
  currentTooltip: '',
}

export const ui = (
  state: UiState = initialState,
  action: ReduxAction,
): UiState => {
  switch (action.type) {
    case 'SET_DROPDOWN': {
      const { id } = action.payload
      return {
        ...state,
        currentDropDown: id,
      }
    }
    case 'SET_TOOLTIP': {
      const { id } = action.payload
      return {
        ...state,
        currentTooltip: id,
      }
    }
    default:
      return state
  }
}
